<button
  class="toggle-chip"
  type="button"
  [ngClass]="size()"
  [class.active]="active()"
  [attr.aria-pressed]="active()"
  [style.--chip-color]="color()"
  (click)="clicked.emit()"
>
  @if (currentIcon(); as chipIcon) {
    <ptl-icon [icon]="chipIcon" [size]="size()" [strokeWidth]="1.5" [color]="'currentColor'"></ptl-icon>
  }
  {{ label() }}
</button>
